import { toast } from "./toast";
import { parseQuotaError } from "./freemium";
import { hapticSuccess } from "./telegram";

/**
 * Instant, uniform feedback for every save: haptic + green check toast fired
 * the moment the optimistic update lands, never after the network settles.
 */
export function notifySaved(message = "Saved Successfully") {
  hapticSuccess();
  toast.success(message, { duration: 1500 });
}

const SLOW_MS = 2000;

/**
 * Measures a save and, if the cloud write outlives 2s, swaps the silence for a
 * non-blocking "Still syncing…" note instead of a spinner.
 */
export function trackSave(label: string) {
  const start = typeof performance !== "undefined" ? performance.now() : Date.now();
  const toastId = `sync-${label}-${start}`;
  const timer =
    typeof window !== "undefined"
      ? window.setTimeout(() => toast.loading("Still syncing…", { id: toastId }), SLOW_MS)
      : undefined;

  return (outcome: "ok" | "error" = "ok") => {
    if (timer !== undefined) window.clearTimeout(timer);
    toast.dismiss(toastId);
    const ms = Math.round((typeof performance !== "undefined" ? performance.now() : Date.now()) - start);
    if (import.meta.env.DEV) {
      console.debug(`[save] ${label} ${outcome} in ${ms}ms`);
    }
    return ms;
  };
}
/**
 * Turns a server error into text a student can act on. Freemium quota denials
 * become the upgrade message; everything else passes through unchanged.
 */
export function friendlyError(error: unknown): string {
  const quota = parseQuotaError(error);
  if (quota) return quota.message;
  return error instanceof Error ? error.message : String(error ?? "Something went wrong");
}
